module.exports = __webpack_public_path__ + "static/img/icon10.3fc9189c.gif";